type DateInput = string | number | Date;

export const formatDate = (
  dateString: DateInput,
  isSeparator: boolean = false
) => {
  if (!dateString) return "";

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: isSeparator ? "short" : "long",
    year: "numeric",
  };

  const formattedDate = new Date(dateString).toLocaleDateString(
    "en-GB",
    options
  );

  if (isSeparator) {
    const [day, month, year] = formattedDate.split(" ");
    return `${day} ${month.replace(",", "")}, ${year}`;
  }

  return formattedDate;
};

export const shortFormatDate = (timestamp: DateInput) => {
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear().toString().slice(-2);
  return `Posted on ${day} ${month} '${year}`;
};

export const newsBlogFormatDate = (timestamp: DateInput) => {
  const date = new Date(timestamp);
  const now: Date = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diff < 60) {
    return "Just Now";
  } else if (diff < 3600) {
    const minutes = Math.floor(diff / 60);
    return `${minutes} ${minutes === 1 ? "Minute" : "Minutes"} Ago`;
  } else if (diff < 86400) {
    const hours = Math.floor(diff / 3600);
    return `${hours} ${hours === 1 ? "Hour" : "Hours"} Ago`;
  } else if (diff < 604800) {
    const days = Math.floor(diff / 86400);
    return `${days} ${days === 1 ? "Day" : "Days"} Ago`;
  } else {
    return date.toDateString();
  }
};

export const getSortedNewsData = (newsData: any[]) => {
  return newsData?.toSorted((a, b) => {
    const dateA = new Date(a?.updatedAt);
    const dateB = new Date(b?.updatedAt);
    return dateB.getTime() - dateA.getTime();
  });
};
